import API_BASE_URL from "../config";

const baseUrl = API_BASE_URL;

const API_ENDPOINTS = {
  signUpApi: `${baseUrl}/technicians/login`,
  addPatient: `${baseUrl}/patient/add-patient`,
  getTestResults: `${baseUrl}/patient/get-patientTest/SC23F000005`,
  addTestReport: `${baseUrl}/test/add-testResult`,
  calculateTestPrice: `${baseUrl}/testPrice/post-price_single_doc`,
  payOnline: `${baseUrl}/payment/makePayment`,
  promoCode: `${baseUrl}/promocode/validate`,
  addReport: `${baseUrl}/report/add-report/`,
  bodyCompostionApi: `https://localhost:3003/api/data`,
  getFactor: `${baseUrl}/heightFactor`,
  getTestResultsLocal: `${baseUrl}/test/getTestResult/`,
  getLabTestResult: `${baseUrl}/labTest/GetResult`,
  getPaymentStatus: `${baseUrl}/payment/verifyPayment`,
  checkHead: `${baseUrl}/patient/checkHead`,
  sendPdf: `${baseUrl}/report/sendReport`,
  validatePromoCode: `${baseUrl}/promocode/validate`,
  applyPromoCode: `${baseUrl}/promocode/apply`,
  fetchAllTest:`${baseUrl}/labTest/GetAll`,
  fetchResult:`${baseUrl}/test-two/getResults`
};

export default API_ENDPOINTS;
